import * as Yup from 'yup';

export default Yup.object().shape({
  search: Yup.string().required('È necessario inserire un testo di ricerca'),
});
